// extracted by mini-css-extract-plugin
export default {"ImagesList":"ImagesList_ImagesList__eK1Zt","loading":"ImagesList_loading__US7+B"};